var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-logo",on:{"click":function($event){_vm.$router.replace({ name: 'home' }).catch(() => {})}}},[_c('img',{staticClass:"header-logo__img",attrs:{"src":_vm.logo,"alt":"logo"}}),_c('img',{staticClass:"header-logo__img--sm",attrs:{"src":_vm.logoMobile,"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }